module.exports = __webpack_public_path__ + "img/ALC-logo.e1bc99b6.svg";